"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentBI = exports.createBIEventFactory = exports.createBIEvent = void 0;
var tslib_1 = require("tslib");
var createBIEvent = function (_a) {
    var src = _a.src, evid = _a.evid, fields = _a.fields;
    return ({
        evid: evid,
        src: src,
        fields: fields,
    });
};
exports.createBIEvent = createBIEvent;
var createBIEventFactory = function (src) {
    return function (evid, fields) {
        return exports.createBIEvent({ evid: evid, src: src, fields: fields });
    };
};
exports.createBIEventFactory = createBIEventFactory;
var createComponentBI = function (
// TODO: Use real editorAPI types
editorAPI, extraParams) {
    if (extraParams === void 0) { extraParams = {}; }
    return function (data, props) {
        return editorAPI.selectedComponent.sendSelectedComponentBI(data, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, props), { component_type: editorAPI.components.getType(editorAPI.selection.getSelectedComponents()[0]) }), extraParams));
    };
};
exports.createComponentBI = createComponentBI;
//# sourceMappingURL=createBI.js.map